const SaveSvg = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <mask id="mask0_7443_25667" style={{ maskType: "alpha" }} maskUnits="userSpaceOnUse" x="0" y="0" width="16" height="16">
        <rect width="16" height="16" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_7443_25667)">
        <mask id="mask1_7443_25667" style={{ maskType: "alpha" }} maskUnits="userSpaceOnUse" x="2" y="2" width="12" height="12">
          <rect x="2" y="2" width="12" height="12" fill="#AC2D2D" />
        </mask>
        <g mask="url(#mask1_7443_25667)">
          <path
            d="M2.7002 2.59961H10.71C10.7363 2.59961 10.7616 2.61042 10.7803 2.62891L13.3711 5.21973C13.3896 5.23844 13.4004 5.26372 13.4004 5.29004V13.2998C13.4004 13.355 13.355 13.4004 13.2998 13.4004H2.7002C2.64497 13.4004 2.59961 13.355 2.59961 13.2998V2.7002C2.59961 2.64497 2.64497 2.59961 2.7002 2.59961Z"
            stroke="white"
            strokeWidth="1.2"
          />
          <path
            d="M5 13V9.1C5 9.04477 5.04477 9 5.1 9H10.4C10.4552 9 10.5 9.04477 10.5 9.1V13"
            stroke="white"
            strokeWidth="1.2"
            strokeLinecap="round"
          />
          <path d="M5 5.75H9" stroke="white" strokeWidth="1.2" strokeLinecap="round" />
        </g>
      </g>
    </svg>
  );
};

export default SaveSvg;
